export default () => ({
  isOpen: true,

  initCountdownBar() {
    // Check if the banner was previously closed by the user
    if (localStorage.getItem("countdownBannerClosed") === "true") {
      this.isOpen = false;
      return;
    }

    const countdownElements = document.querySelectorAll("[data-countdown]");
  
    countdownElements.forEach((element) => {
      const time = new Date(element.getAttribute("data-countdown"));
      const targetTime = parseInt(time.getTime(), 10);

      // Define active and ended Tailwind classes
      const countdownActiveClass = "grid grid-cols-4 gap-2 w-full max-w-[450px] mx-auto";
      const countdownEndedClass = "text-16-100 flex items-center justify-center text-center w-full max-w-[450px] mx-auto";

      if (isNaN(targetTime) || targetTime <= new Date().getTime()) {
        // Apply ended class and set message
        element.className = countdownEndedClass;
        element.textContent = "The countdown has ended.";
        return;
      }

      // Select individual spans for days, hours, minutes, and seconds
      const daysSpan = element.querySelector(".countdown-days");
      const hoursSpan = element.querySelector(".countdown-hours");
      const minutesSpan = element.querySelector(".countdown-minutes");
      const secondsSpan = element.querySelector(".countdown-seconds");

      // Apply active class initially
      element.className = countdownActiveClass;

      const updateCountdown = () => {
        const now = new Date().getTime();
        const distance = targetTime - now;

        if (distance > 0) {
          const days = Math.floor(distance / (1000 * 60 * 60 * 24));
          const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((distance % (1000 * 60)) / 1000);

          // Hide the days span if less than 1 day is left
          if (days < 1) {
            daysSpan.style.display = "none";
            element.classList.remove("grid-cols-4");
            element.classList.add("grid-cols-3");
          } else {
            daysSpan.style.display = "inline"; // Ensure it's visible for > 1 day
            daysSpan.textContent = `${days < 10 ? '0' : ''}${days}D`;
            element.classList.remove("grid-cols-3");
            element.classList.add("grid-cols-4");
          }

          // Update other spans with the formatted time
          hoursSpan.textContent = `${hours < 10 ? '0' : ''}${hours}H`;
          minutesSpan.textContent = `${minutes < 10 ? '0' : ''}${minutes}M`;
          secondsSpan.textContent = `${seconds < 10 ? '0' : ''}${seconds}S`;
        } else {
          // Countdown has ended; apply ended class and set message
          element.className = countdownEndedClass;
          element.textContent = "The countdown has ended.";
          clearInterval(intervalId); // Stop updating once countdown ends
        }
      };

      // Initialize the countdown and set interval
      updateCountdown();
      const intervalId = setInterval(updateCountdown, 1000);
    });
  },

  closeBanner() {
    this.isOpen = false;
    localStorage.setItem("countdownBannerClosed", "true"); // Store closed state
  }
});
